var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "jfrslq6rva",
    d: "M16.667 3.333H3.333c-.916 0-1.658.75-1.658 1.667l-.008 10c0 .917.75 1.667 1.666 1.667h13.334c.916 0 1.666-.75 1.666-1.667V5c0-.917-.75-1.667-1.666-1.667zm0 3.334L10 10.833 3.333 6.667V5L10 9.167 16.667 5v1.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-395 -294) translate(385 284) translate(10 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "66eiyymsib",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jfrslq6rva"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#66eiyymsib)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-email.48e19c54.svg";
export { ForwardRef as ReactComponent };